module.exports = __webpack_public_path__ + "assets/img/team/andreas-herweg.jpg";